import { useEffect } from "react";

/**
 * GhlFormEmbed — inline GHL form embed.
 *
 * Loads `form_embed.js` once per page (idempotent). Renders the iframe with
 * brand-compliant styles: no border-radius (brand law: `border-radius: 0`
 * globally), no shadow, no borders. GHL's script auto-resizes the iframe via
 * postMessage; the height prop is used only as an initial baseline.
 */
const GHL_EMBED_SCRIPT_SRC = "https://link.msgsndr.com/js/form_embed.js";

const GhlFormEmbed = ({
  formId,
  formName = "General Request",
  title = "General Request",
  height = 1133,
  testId = "ghl-form-embed",
}) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${GHL_EMBED_SCRIPT_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = GHL_EMBED_SCRIPT_SRC;
    s.type = "text/javascript";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <iframe
      src={`https://api.leadconnectorhq.com/widget/form/${formId}`}
      style={{
        width: "100%",
        height: `${height}px`,
        border: "none",
        borderRadius: 0, // brand law: no rounded corners
        background: "transparent",
        display: "block",
      }}
      id={`inline-${formId}`}
      data-layout="{'id':'INLINE'}"
      data-trigger-type="alwaysShow"
      data-trigger-value=""
      data-activation-type="alwaysActivated"
      data-activation-value=""
      data-deactivation-type="neverDeactivate"
      data-deactivation-value=""
      data-form-name={formName}
      data-height={height}
      data-layout-iframe-id={`inline-${formId}`}
      data-form-id={formId}
      title={title}
      data-testid={testId}
    />
  );
};

export default GhlFormEmbed;
